<template>
<div>
  <div class="row justify-content-center">
    <div class="col-md-12 col-11" >
          <div class="row justify-content-center" style="background:#f6f6f6;">
            <div class="col-md-12">
              <br>
                  <center>
                          <h4 style="color:#E63780;"><b>Mis Solicitudes</b></h4>
                          <p>Selecciona:</p> 
                          <div class="row justify-content-center">
                            <div class="col-md-2">
                              <button  class="btn float-center btn-sm mt-2 btn-block" type="button" style="font-size:16px; color:#fff; border-radius: 26px;  background:#E63780; border-color:#E63780;" 
                                @click="cambioSelect(1)">
                                Nuevas solicitudes
                              </button> 
                            </div>
                            <div class="col-md-2">
                              <button  class="btn float-center btn-sm mt-2 btn-block" type="button" style="font-size:16px; color:#fff; border-radius: 26px;  background:#F28D15; border-color:#F28D15;" 
                                @click="cambioSelect(2)">
                                En proceso 
                              </button> 
                            </div>
                            <div class="col-md-2">
                              <button  class="btn float-center btn-sm mt-2 btn-block" type="button" style="font-size:16px; color:#fff; border-radius: 26px;  background:#A13EA1; border-color:#A13EA1;" 
                                @click="cambioSelect(0)">
                                Cerradas
                              </button> 
                            </div>
                          </div>
                  </center>
              <br>
            </div>  
        </div> 
    </div>
    <div class="col-md-12 col-11" > 
      <br v-if="isMobile"> 
      <br> 
       <div class="form-group mt-5 ">
         <div class="row">
          <div class="col-md-1"></div>
            <div class="col-md-2 mt-5" >
                <div class="input-group" :style="isMobile ? '' : 'margin-left: -15px;'">
                    <input type="text" v-model="buscar" class="form-control " placeholder="Buscar No. Folio" style="border-radius: 30px;"> 
                </div>
            </div>
             <div class="col-md-1"></div>
            <div class="col-md-5 mt-4" :style="isMobile ? '' : 'margin-left: -77px;'">
               <center>
                <template v-if="cambio_solicitud == 1">
                  <h4 style="color:#E63780;"><b>Nuevas Solicitudes</b></h4>
                </template>
                <template v-if="cambio_solicitud == 2">
                  <h4 style="color:#F28D15;"><b>En proceso</b></h4>
                </template>
                <template v-if="cambio_solicitud == 0">
                  <h4 style="color:#A13EA1;"><b>Cerradas</b></h4>
                </template>  
               </center>
            </div>
            <div class="col-md-3 mt-4">
                <button  class="btn float-center btn-sm mt-2" type="button" :style="isMobile ? 'font-size:14px; color:#fff; border-radius: 26px;  background:#019DF4; border-color:#019DF4; width: 100%;' :
                   'font-size:14px; color:#fff; border-radius: 26px;  background:#019DF4; border-color:#019DF4; width: 47%;'" 
                    @click="mostrarListado()">
                    Nueva solicitud de IDPDV
                  </button> 
                  <button  :class="isMobile ? 'btn float-center btn-sm mt-2' : 'btn float-center btn-sm mt-2 ml-4'" type="button" :style="isMobile ? 'font-size:14px; color:#fff; border-radius: 26px;  background:#162B40; border-color:#162B40; width: 100%;'
                   : 'font-size:14px; color:#fff; border-radius: 26px;  background:#162B40; border-color:#162B40; width: 47%;'" 
                    @click="mostrarBaja()">
                    Edición y/o Baja de IDPDV
                  </button> 
            </div> 
          </div>
        </div>
        <div class="table-responsive mt-3">
            <table class="table table-hover table-striped mt-3" >
                <thead class="bg-primary text-white">
                <tr> 
                    <th scope="col" style="font-size:17px; width: 4%;" class="text-center"></th>
                    <th scope="col" style="font-size:17px; width: 4%;" class="text-center">Folio</th>
                    <th scope="col" style="font-size:17px;" class="text-center">Nombre</th>
                    <th scope="col" style="font-size:17px;" class="text-center" v-if="cambio_solicitud != 2">DI</th> 
                    <th scope="col" style="font-size:17px;" class="text-center" v-if="cambio_solicitud == 1">Distribuidor</th>
                    <th v-if="isMobile"></th>
                    <th scope="col" style="font-size:17px;" class="text-center">Fecha</th> 
                    <th v-if="isMobile"></th>
                    <th scope="col" style="font-size:17px;" class="text-center" v-if="cambio_solicitud != 1">Estatus</th> 
                    <th scope="col" style="font-size:17px;" class="text-center" v-if="cambio_solicitud != 1"></th> 
                    <th scope="col" :style="isMobile ? 'font-size:17px;' : 'font-size:17px;   width: 30%;'" class="text-center" v-if="cambio_solicitud == 2"></th>
                    <th scope="col" style="font-size:17px;  width: 30%;" class="text-center" v-if="cambio_solicitud != 1">Comentarios</th>
                    <th scope="col" :style="isMobile ? 'font-size:17px;' : 'font-size:17px;   width: 12%;'" class="text-center" v-if="cambio_solicitud != 2"></th> 
                    <th v-if="isMobile"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="list in listado" :key="list.id">  
                    <td class="text-center"></td>
                    <td class="text-center">
                      <b>{{list.id}}</b>
                    </td>  
                    <td class="text-center">
                      <template v-if="list.tipo_solicitud">
                        {{list.tipo_solicitud}} - <b>{{ list.idpdv }}</b>
                      </template>
                      <template>
                       {{list.nombre_solicitud}}
                      </template>
                    </td>
                    <td class="text-center" v-if="cambio_solicitud != 2"><template v-if="!list.tipo_solicitud || list.tipo_solicitud == 'Reasignar DI al IDPDV'">{{list.di}}</template></td>
                    <td class="text-center" v-if="cambio_solicitud == 1"><template v-if="!list.tipo_solicitud || list.tipo_solicitud == 'Reasignar DI al IDPDV'">{{list.nombre_distribuidor}}</template></td> 
                    <td :colspan="isMobile ? '3' : ''" class="text-center">{{list.updated_at | fechaFormato}}</td>  
                    <td class="text-center" v-if="cambio_solicitud == 2">
                      <h5 style="color:#F28D15;" v-if="list.cancelado == 0">En proceso</h5> 
                      <h5 style="color:#E63780;" v-if="list.cancelado == 1">Rechazada</h5> 
                    </td> 
                    <td class="text-center" :style="list.cancelado == 0 ? 'color:#A13EA1;' : 'color:#E63780;'" v-else-if="cambio_solicitud == 0">
                      <template v-if="list.tipo_solicitud">
                        <h5 style="color:#A13EA1;" v-if="list.cancelado == 0">Cerrado</h5>  
                        <h5 style="color:#E63780;" v-if="list.cancelado == 1">Rechazado</h5>  
                      </template>
                      <template v-else>
                        <h5 style="color:#A13EA1;" v-if="list.cancelado == 0">IDPDV enviado</h5>  
                        <h5 style="color:#E63780;" v-if="list.cancelado == 1">IDPDV rechazado</h5>  
                      </template>
                      
                      <hr>
                      <template  v-if="list.cancelado == 0 && !list.tipo_solicitud">{{ list.idpdv }}</template>
                      <template  v-if="list.cancelado == 1">Folio cerrado</template>
                    </td> 
                   <td class="text-center" v-if="cambio_solicitud != 1">
                      <template  v-if="list.cancelado == 1"><b>Motivo rechazo</b><br> {{ list.motivo_cancelado }}</template>
                    </td> 
                    <td class="text-center" v-if="cambio_solicitud == 2">
                         <div class="row justify-content-center"> 
                            <div class="col-md-4 col-12">
                              <button  v-if="list.estatus == 2 && list.cancelado == 1" class="btn float-center btn-sm btn-block" type="button" style="font-size:16px; color:#fff; border-radius: 26px;  background:#019DF4; border-color:#019DF4;" 
                                @click="editaSolicitud(list)">
                                Editar
                              </button>  
                            </div> 
                            
                            <div class="col-md-4 col-12">
                              <br v-if="isMobile"> 
                              <button  class="btn float-center btn-sm btn-block" type="button" style="font-size:16px; color:#fff; border-radius: 26px;  background:#5CB615; border-color:#5CB615;" 
                                @click="abrirDetalle(list)">
                                Detalle
                              </button> 
                            </div>
                          </div>
                    </td> 
                    <td class="text-center" v-if="cambio_solicitud != 1">
                       <b-card  style="border-color: #696969;  -webkit-border-radius: 20px;">
                          <div class="text-left"> 
                                <template v-if="list.comentario.length > 0">
                                    <b><b-avatar :style="list.comentario[0].iduser == user.id  ? 'background: #3ABF30;' : 'background: #000;'" size="sm"></b-avatar>
                                         <template v-if="list.comentario[0].user.gestor_idpdv == 1"> Usuario - {{ list.comentario[0].user.nombre }}</template>
                                         <template v-if="list.comentario[0].user.gestor_idpdv == 2"> <span v-if="list.comentario[0].rechazo == 1"> Motivo Rechazo</span><span v-else> Administrador</span></template> 
                                    </b>
                                    <div class="row">
                                        <div class="col-1"></div>
                                        <div class="col-11 col-lg-12">
                                         <p :style="!isMobile ? 'text-indent: 1.7em;' : ''">{{list.comentario[0].comentario}} <em style="font-size:small;">({{list.comentario[0].created_at | fechaFormato}}) </em></p>
                                        </div>
                                   </div>
                                </template>
                                <template v-else>
                                  <span style="color:#999999; font-size: 18px;">No hay comentarios.</span>
                                </template>
                            </div>
                            <div class="row" style="margin-top: -20px;">
                                <div class="col-md-4"></div> 
                                <div class="col-md-7 text-right">
                                  <br>
                                    <u style="cursor: pointer; color: #3ABF30; font-size: 14px;" @click="verMensaje(list)">Comentarios</u> 
                                </div>
                            </div>  
                        </b-card>
                    </td>   
                    <td  :colspan="isMobile ? '2' : ''" class="text-center" v-if="cambio_solicitud != 2">
                          <button  class="btn float-center btn-sm btn-block" type="button" :style="isMobile ? 'font-size:16px; color:#fff; border-radius: 26px;  background:#5CB615; border-color:#5CB615; width: 100%;' :
                           'font-size:16px; color:#fff; border-radius: 26px;  background:#5CB615; border-color:#5CB615; width: 60%;'" 
                            @click="abrirDetalle(list)">
                            Detalle
                          </button> 
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-12" v-if="listado.length == 0" style="background: #FCFCFC; box-shadow: inset 0 0 10px 0 #CDCDCD;">
            <center>
                <br>
               <h4 style="color:#098FD6; ">No hay registros.</h4> 
                <div class="col-md-4" v-if="listado.length == 0">
                    <hr style="border-top: 5px solid #CAF5A8 !important;  opacity :2;">
                </div>
            </center>
        </div>
        <br><br> 
    </div> 
  </div>   


    <b-modal id="detalle_solicitud" :title="obj.tipo_solicitud ? 'INFORMACIÓN EDICIÓN y/o BAJA DE IDPDV FOLIO ' + obj.id : 'DETALLE SOLICITUD FOLIO ' + obj.id" hide-footer   size="lg"  >
      <div class="row justify-content-center">
        <div  class="col-md-10 text-center" style="font-size: 19px;">
          <template v-if="obj.tipo_solicitud">
            <b>Nombre solicitud: </b> {{ obj.nombre_idpdv }} <br>
            <b class="mt-2">IDPDV: </b> {{ obj.idpdv }} <br>
            <b>Tipo solicitud: </b> {{ obj.tipo_solicitud }} <br>
            <template v-if="obj.user">
              <b class="mt-2">Correo del solicitante: </b> {{ obj.user.email }} <br>  
            </template>
             <template v-if="obj.tipo_solicitud == 'Reasignar DI al IDPDV'"><b class="mt-2">DI Actual: </b> {{ obj.di }} <br></template>
             <template v-if="obj.tipo_solicitud == 'Reasignar DI al IDPDV'"><b class="mt-2">Nuevo DI: </b> {{ obj.di_nuevo }} <br></template>
             <template v-if="obj.tipo_solicitud == 'Reasignar DI al IDPDV'"><b class="mt-2">Nombre DI Actual: </b> {{ obj.nombre_distribuidor }} <br></template>
             <template v-if="obj.tipo_solicitud == 'Reasignar DI al IDPDV'"><b class="mt-2">Nuevo Nombre: </b> {{ obj.nombre_di_nuevo }} <br></template>
          </template>
          <template v-else>
              <b>Nombre solicitud: </b> {{ obj.nombre_solicitud }} <br>
              <b class="mt-2">DI: </b> {{ obj.di }} <br>
              <b class="mt-2">Nombre distribuidor: </b> {{ obj.nombre_distribuidor }} <br>
              <b class="mt-2">Calle y Número: </b> {{ obj.calle_numero }} <br>
              <b class="mt-2">NIR / Zona: </b> {{ obj.nir_zona }} <br>
              <b class="mt-2">Municipio: </b> {{ obj.municipio }} <br>
              <b class="mt-2">Estado: </b> {{ obj.estado }} <br>
              <b class="mt-2">C.P.: </b> {{ obj.cp }} <br>
              <template v-if="obj.tipo_proyecto"><b class="mt-2">Tipo Proyecto: </b> {{ obj.tipo_proyecto }} <br></template>
              <template v-if="obj.tipo_idpdv"><b class="mt-2">Tipo IDPDV: </b> {{ obj.tipo_idpdv }} <br></template>
              <template v-if="obj.tipo_proyecto == 'Prepago masivo'"><b class="mt-2">Tipo Modelo: </b> {{ obj.tipo_modelo }} <br> </template>
              <template v-if="obj.user">
              <b class="mt-2">Correo del solicitante: </b> {{ obj.user.email }} <br>  
              </template>
          </template>
          <div class="row justify-content-center mt-3">
            <div class="col-md-4 mt-3" v-for="list in obj.archivo" :key="list.id">
              <!-- <img crossorigin="anonymous" :src="$api.baseUriFiles+'gestor/' + list.testigo" alt="Image"  :width="isMobile ? 250 : 400"> -->
               <a target="_blank" :href="$api.baseUriFiles+'gestor/' + list.testigo"><u style="font-size: 22px; color:#019DF4; cursor: pointer;">Testigo</u></a>
            </div>
          </div>
          <br>
        </div> 
      </div>
    </b-modal> 

    <b-modal id="edita_solicitud" :title="'DETALLE SOLICITUD FOLIO ' + obj.id" hide-footer   size="lg"  >
      <b-form @submit="store">
      <div class="row justify-content-center">
        <div  class="col-md-5">
           <label for="" style="font-size: 17px;" class="ml-3">Nombre de la solicitud:</label>
           <b-form-input placeholder="Nombre" v-model="nombre_solicitud" class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/>
            <small v-if="errors.includes('nombre_solicitud')" class="text-danger mt-2 text-left">
                <i class="fas fa-exclamation-circle"></i>
                Este campo es obligatorio
            </small> 
         </div>
         <div  class="col-md-5">
            <label for="" style="font-size: 17px;" class="ml-3">Escribe DI:</label>
            <b-form-input placeholder="000000" v-model="di" class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/>
            <small v-if="errors.includes('di')" class="text-danger mt-2 text-left">
                <i class="fas fa-exclamation-circle"></i>
                Este campo es obligatorio
            </small> 
         </div>
         <div  class="col-md-5 mt-3">
              <label for="" style="font-size: 17px;" class="ml-3">Nombre del distribuidor:</label>
              <b-form-input placeholder="Distribuidor" v-model="nombre_distribuidor"  class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/>
              <small v-if="errors.includes('nombre_distribuidor')" class="text-danger mt-2 text-left">
                  <i class="fas fa-exclamation-circle"></i>
                  Este campo es obligatorio
              </small> 
          </div>
          <div  class="col-md-5 mt-3">
              <label for="" style="font-size: 17px;" class="ml-3">Calle y número:</label>
              <b-form-input placeholder="Calle / 0000" v-model="calle" class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/>
              <small v-if="errors.includes('calle')" class="text-danger mt-2 text-left">
                  <i class="fas fa-exclamation-circle"></i>
                  Este campo es obligatorio
              </small> 
          </div>
          <div  class="col-md-5 mt-3">
               <label for="" style="font-size: 17px;" class="ml-3">NIR / Zona:</label>
              <b-form-input placeholder="00000" v-model="nir" class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/>
              <small v-if="errors.includes('nir')" class="text-danger mt-2 text-left">
                  <i class="fas fa-exclamation-circle"></i>
                  Este campo es obligatorio
              </small> 
          </div>
          <div  class="col-md-5 mt-3">
               <label for="" style="font-size: 17px;" class="ml-3">Municipio:</label>
              <b-form-input placeholder="Escribe aquí" v-model="municipio" class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/>
              <small v-if="errors.includes('municipio')" class="text-danger mt-2 text-left">
                  <i class="fas fa-exclamation-circle"></i>
                  Este campo es obligatorio
              </small> 
          </div>
          <div  class="col-md-5 mt-3">
               <label for="" style="font-size: 17px;" class="ml-3">Estado:</label>
              <b-form-input placeholder="Escribe aquí" v-model="estado" class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/>
              <small v-if="errors.includes('estado')" class="text-danger mt-2 text-left">
                  <i class="fas fa-exclamation-circle"></i>
                  Este campo es obligatorio
              </small> 
          </div>
          <div  class="col-md-5 mt-3">
               <label for="" style="font-size: 17px;" class="ml-3">C.P.:</label>
              <b-form-input placeholder="00000" v-model="cp" class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/>
              <small v-if="errors.includes('cp')" class="text-danger mt-2 text-left">
                  <i class="fas fa-exclamation-circle"></i>
                  Este campo es obligatorio
              </small> 
          </div> 
            <!-- <div class="col-md-4 mt-4" v-for="list in obj.archivo" :key="list.id">
              <center>
               <a target="_blank" :href="$api.baseUriFiles+'gestor/' + list.testigo"><u style="font-size: 22px; color:#019DF4; cursor: pointer;">Testigo</u></a>
               <div class="row justify-content-center">
                 <div class="col-md-4" v-if="obj.archivo.length > 1"><u style="color: #E63780; cursor: pointer;">Eliminar</u></div>
                 <div class="col-md-4"><u style="color: #5CB615; cursor: pointer;">Cambiar</u></div>
               </div>
              </center> 
            </div>  -->
            <div class="col-md-12">
              <hr>
            </div>
            <div  class="col-md-2 mt-3">
                   <button  class="btn float-center btn-sm mt-2 btn-block" type="submit" style="font-size:16px; color:#fff; border-radius: 26px;  background:#5CB615; border-color:#5CB615;">
                      Enviar <b-spinner small v-if="loader"></b-spinner> 
                    </button> 
            </div>
            <div  class="col-md-2 mt-3">
                   <button  class="btn float-center btn-sm mt-2 btn-block" type="button" style="font-size:16px; color:#fff; border-radius: 26px;  background:#E63780; border-color:#E63780;" 
                      @click="cancelaDetalle()">
                      Cancelar
                    </button> 
            </div> 
      </div>
      </b-form>
    </b-modal> 
 
    <b-modal id="historialprueba" title="Comentarios" hide-footer size="lg" hide-header>
        <div class="row">
          <div class="col-md-11"></div>
          <div class="col-md-1"><u class="mt-3" style="color:#fff; cursor: pointer; font-size:20px;" @click="$bvModal.hide('historialprueba')">X</u></div> 
        </div> 
        <div class="text-center"> 
          <h4 class="text-white mt-2">COMENTARIO</h4>
        </div>
        <div class="row justify-content-center"  v-if="cambio_solicitud != 0">
            <div :class="isMobile ? 'col-12' : 'col-md-10 mt-3'">
                <input type="text" class="form-control" placeholder="Nuevo comentario" v-model="comentario_seccion" style="border-radius: 30px;">
            </div> 
            <div class="col-md-3 mt-3 text-center">
             <u style="color:#fff; cursor: pointer; font-size: 20px;" @click="enviarComentario()">Enviar <b-spinner small v-if="loaderComent"></b-spinner></u>  
            </div>
        </div>
        <div class="text-left">
            <div id="global" class="mt-3">
                <div id="mensajes" v-for="com in arrayComent" :key="com.id">
                    <div class="texto">
                        <b><b-avatar :style="com.iduser == user.id ? 'background: #3ABF30;' : 'background: #000;'" size="sm"></b-avatar>
                           <template v-if="com.user.gestor_idpdv == 1"> Usuario - {{ com.user.nombre }}</template>
                           <template v-if="com.user.gestor_idpdv == 2"> <span v-if="com.rechazo == 1"> Motivo Rechazo</span><span v-else> Administrador</span></template> 
                         </b>
                         <div class="row">
                             <div class="col-1"></div>
                             <div class="col-11 col-lg-12">
                                <p :style="!isMobile ? 'text-indent: 1.7em;' : ''">{{com.comentario}} <em style="font-size:small;">({{com.created_at | fechaFormato}}) </em>   </p> 
                             </div>
                         </div> 
                    </div>                             
                </div>
            </div>
        </div>
    </b-modal>
</div>
</template>
<script>
import Swal from 'sweetalert2' 
import moment  from 'moment'; 
export default {
 name:"Listado", 
  data() {
    return {
        arrayList:[],
        buscar:"", 
        exh:moment().format("YYYY-MM-DD"), 
        isMobile: this.$mobile(), 
        // 
        cambio_solicitud:1,
        obj:{},
        errors:[],
        nombre_solicitud:"",
        di:"",
        nombre_distribuidor:"",
        calle:"",
        nir:"",
        municipio:"",
        estado:"",
        cp:"",
        idedit:0,
        loader:false,
        comentario_seccion:"",
        nombre_archivo:"",
        archivo_comentario:"",
        loaderComent:false,
        arrayComent:[]
    }
  },
    filters: {
        fechaA:function(value) {
            if (value) {
                moment.locale('es')
                return moment(String(value)).format('YYYY-MM-DD')
            }
        },
        fechaFormato:function(value) {
            if (value) {
                moment.locale('es')
                return moment(String(value)).format('YYYY-MM-DD  LTS')
            }
        },
    },
  computed:{
    user() {
        return this.$store.getters.getInfoUser;
    },
    listado(){
        
            if (this.buscar == "") {          
                return this.arrayList;
            }else{
                return   this.arrayList.filter(item => {
                           return  item.nombre_solicitud?.toLowerCase().includes(this.buscar.toLowerCase())  ||
                                   item.id?.toString().toLowerCase().includes(this.buscar.toLowerCase())
                        ;
                });
            }  
        

    },
  },
  methods: {  
    cambioSelect(id){
      this.arrayList = [];
      this.cambio_solicitud = id;
      this.listadoAct();
    },
    fileSelect(event) {
        this.archivo_comentario = event.target.files[0];
        this.nombre_archivo =  event.target.files[0].name;
    },
    verMensaje(item){
      this.obj = item;
      this.getComentario();
       this.$bvModal.show('historialprueba');
    },
    mostrarListado(){
      this.$bus.$emit("menuRegistrauser");
    },
    mostrarBaja(){
      this.$bus.$emit("menuBajauser");
    },
    abrirDetalle(item){
      this.obj = item;
      this.$bvModal.show('detalle_solicitud');
    },    
    cancelaDetalle(){ 
      this.nombre_solicitud = "";
      this.di = "";
      this.nombre_distribuidor = "";
      this.calle = "";
      this.nir = "";
      this.municipio = "";
      this.estado = "";
      this.cp = "";
      this.idedit = 0;
      this.$bvModal.hide('edita_solicitud');
    },
    editaSolicitud(item){
      this.obj = item;
      // this.nombre_solicitud = this.obj.nombre_solicitud;
      // this.di = this.obj.di;
      // this.nombre_distribuidor = this.obj.nombre_distribuidor;
      // this.calle = this.obj.calle_numero;
      // this.nir = this.obj.nir_zona;
      // this.municipio = this.obj.municipio;
      // this.estado = this.obj.estado;
      // this.cp = this.obj.cp;
      // this.idedit = this.obj.id;
      // this.$bvModal.show('edita_solicitud');
         window.location.href = this.obj.tipo_solicitud ? "https://gestionidpdv.asistentemovistar.com.mx/registroBaja/" + this.obj.id : "https://gestionidpdv.asistentemovistar.com.mx/registro/" + this.obj.id;

    },    
    getComentario(){
       var url= 'admin/gestor/comentario?id='+ this.obj.id;
            this.$api.get(url).then(
                    ({data}) => {
                      console.log(data);
                        this.arrayComent = data.data.list;
                        // this.arrayPromo = data.data.promo;
                    }
                );
    }, 
    listadoAct(){
        var url= 'admin/gestor/index?user='+ this.user.id + '&val='+ this.user.gestor_idpdv + '&solicitud='+ this.cambio_solicitud;
            this.$api.get(url).then(
                    ({data}) => {
                      console.log(data);
                        this.arrayList = data.data.list;
                        // this.arrayPromo = data.data.promo;
                    }
                );
    },
    store(e){
          e.preventDefault();           
          this.errors = [];   
          if(!this.nombre_solicitud){ 
              this.errors.push('nombre_solicitud');  
          }if (!this.di){ 
              this.errors.push('di');  
          }if (!this.nombre_distribuidor){ 
              this.errors.push('nombre_distribuidor');  
          }if (!this.calle){ 
              this.errors.push('calle');  
          }if (!this.nir){ 
              this.errors.push('nir');  
          }if (!this.municipio){ 
              this.errors.push('municipio');  
          }if (!this.estado){ 
              this.errors.push('estado');  
          }if (!this.cp){ 
              this.errors.push('cp');  
          }if(this.errors.length == 0){
              this.loader = true;
              let model = this.prepareModel();
              this.$api.post("admin/gestor/editar", model).then(
              response => {
                  this.loader = false;  
                  Swal.fire(
                  "¡List@!",
                  "Se ha editado correctamente tu solicitud",
                  "success"
                  )
                  this.listadoAct();  
                  this.cancelaDetalle(); 
                  console.log(response)
              },
              error => {
                  this.loader = false;
                  if (error.api) {
                        this.errors = error.api; 
                  }
              }
              )
            }
      },
      prepareModel() { 
            var model = new FormData();   
              model.append("id", this.idedit); 
              model.append("nombre_solicitud", this.nombre_solicitud); 
              model.append("di", this.di); 
              model.append("nombre_distribuidor", this.nombre_distribuidor);
              model.append("calle", this.calle); 
              model.append("nir", this.nir);  
              model.append("municipio", this.municipio); 
              model.append("estado", this.estado); 
              model.append("cp", this.cp);   
              return model;
      }, 
      enviarComentario(){
        if (!this.comentario_seccion)
            {
               Swal.fire({
                  icon: "error",
                  title: "Campo requerido",
                  text: "Escribe un comentario", 
                });
            }else{
              this.loaderComent = true;
               let model = this.prepareModelComent()
                    this.$api.post('admin/gestor/comentarios', model).then( response => { 
                            this.comentario_seccion = "";  
                            this.loaderComent = false;     
                            console.log(response);
                            this.getComentario();
                            this.listadoAct();  
                             Swal.fire(
                              "¡List@!",
                              "Comentario se envió exitosamente.",
                              "success"
                              )               
                        }).catch(error => {
                            this.loaderComent = false;
                            console.log(error);
                        });

            }
      },
      prepareModelComent(){
          let model = new FormData(); 
            model.append("comentario", this.comentario_seccion) 
            model.append("idgestor", this.obj.id)
            model.append("iduser", this.user.id)
            return model;
        },
  },
  mounted(){
    this.listadoAct();  
  } 
}

</script>
<style>
  #hover:hover{
    background:#B2DAFF;
  }

  #tabsCapturaPop .active {
    background: none;
    color: var(--color-primary);
    transition: all 300ms ease;
  }

  #tabsCapturaPop a {
    background: none;
    color: #85848A;
    transition: all 300ms ease;
  }
  #tabsCapturaPop a i {
    transition: all 300ms ease;
    animation-duration: 0.3s;
    font-size: 10px;
  }

  #tabsCapturaPop #capturaBtnReporte .active {
    background: #00a9e0;
    color: white;
  }

  #tabsCapturaPop #capturaBtnReporte {
    margin: 0 20px 0 20px !important;
  }
  
  .input-nav-search::placeholder {
  color: #a8a8a8;
  font-weight: lighter;
  font-family: TelefonicaLight, serif;
  font-size: 15px;
}


  #pagi a {
    background: none;
    color: #85848A;
    transition: all 300ms ease;
  }


.filepond--drop-label {
     background-color: #00a8f1 !important;
    box-shadow: 0px 10px 10px -6px black;
    cursor: pointer;
    color: #fff;
}

.flexbox {
  align-items: center;
  display: flex;
  height: 75px;
  justify-content: center;
  width: auto;
}

.flexbox2 {
  align-items: center;
  display: flex;
  height: 45px;
  justify-content: center;
  width: auto;
}

#global {
	height: 240px;
	width: 100%;
	border: 1px solid #FAFAFA;
	background: #FAFAFA;
	overflow-y: scroll;
}
#mensajes {
	height: auto;
}

#historialprueba .modal-content {
     background-color: #019BEF;
      border-radius: 30px; 
}

</style>
